/** 活动 */
export default {
  create: '开始创建活动',
  createProgramme: 'AI获取方案',
  aiProgramme: 'ai活动方案',
  name: '活动名称',
  placeholder: '请输入活动名称',
  // 报名总人数
  total: '报名总人数',
  // 报名提示
  tips: {
    total: '报名人次不包含取消报名',
    income: '收入不包含退款、打赏、产品销售收入'
  },
  // 报名总收入
  income: '报名总收入',
  // 总点赞数
  likes: '总点赞数',
  table: {
    name: '活动名称',
    status: '活动状态',
    // 总报名人次
    total: '总报名人次',
    // 今日报名人次
    today: '今日报名人次',
    // 上周报名人次
    last_week: '上周报名人次',
    create: '创建时间',
    update: '更新时间',
    start: '开始时间',
    end: '结束时间',
    operate: '操作',
    oper: {
      // 报名数据
      data: '报名数据',
      // 内容配置
      config: '内容配置',
      // 进展配置
      progress: '进展配置',
      // 活动展示
      display: '活动展示',
      // 数据大屏
      screen: '数据大屏',
      // 活动分享
      share: '活动分享',
      // 更多功能
      more: '更多功能',
      mores: {
        // 显示设置
        setting: '显示设置',
        // 广告设置
        ad: '广告设置',
        // 图片直播
        live: '图片直播',
        // 精彩视频
        video: '精彩视频',
        // 签到二维码
        qrcode: '签到二维码',
        // 礼品与奖品
        gift: '礼品与奖品'
      }
    },
    total_number: '共 {total} 条'
  },
  create_form: {
    placeholder: '请输入',
    // 状态字典
    status: {
      '是否确认立刻发布活动?': '是否确认立刻发布活动?'
    },
    // 活动内容
    content: {
      title: '活动内容',
      name: {
        label: '活动名称',
        hover: '输入本次活动的名称，例：第一届儿童绘画展览'
        // hover: '输入本次活动的名称，/ncss_danger-text /t例：第一届儿童绘画展览,/n哈哈哈./ncss_danger-text /t你好/n好看'
      },
      // 活动周期
      cycle: {
        label: '活动周期',
        hover: '整个周期时间，从活动开始到活动结束：例：2024.01.20 ~ 2024.05.20；若未决定，请预估一个时间段'
      },
      // 活动阶段
      stage: {
        title: '活动阶段',
        desc: '当前仅可建立一个阶段，有多个不同阶段，请先完成活动初步创建后，在活动列表中点击该活动的“高级配置”进行配置',
        name: {
          title: '阶段名称',
          hover: '活动阶段的名称，当前只能建立一个阶段；例：第一轮 或 第二轮 或 海选 或 决赛'
        },
        start: {
          title: '报名时间',
          hover: '该阶段的报名开始时间 及 结束时间，请精确到分秒，注：报名时间段以外，无法报名；若未决定，可以后再填'
        },
        hold: {
          title: '举行时间',
          hover: '该阶段举行的开始时间 及 结束时间，请精确到分秒，如：线下展出时间段 或 颁奖典礼时间段；若未决定，可以后再填'
        }
      },
      // 活动海报
      poster: {
        title: '活动海报',
        upload: '点击上传',
        // 提示
        tips: {
          _1: '提示：支持 .jpg、.png 图片格式；图片最大容量不能超过5MB；图片尺寸比例尽量保持1:1，最小尺寸 860px*860px',
          _2: '图片将展示在报名者页面的顶部，点击 查看图例'
        }
      },
      // 活动详情
      detail: {
        desc: '三个板块内容将展示在手机报名页面，报名者可见，点击查看图例',
        placeholder: '请在这里输入',
        title: {
          _1: '活动简介',
          _2: '报名规则',
          _3: '组织机构'
        }
      }
    },
    // 分组信息
    group: {
      title: '分组信息',
      desc: '当前仅可建立一个小组活动，有多个不同的小组活动，请先完成活动初步创建后，在活动列表中点击该活动的 “活动配置 - 分赛配置” 进行配置。活动系统支持，不同小组活动可设置不同的报名费用、报名表单、基础评选、报名形式等一系列设定',
      // 活动分类
      category: {
        title: '活动分类',
        hover: '例：美术；舞蹈；',
        // 添加分类
        add: '添加分类',
        name: '分类名称'
      },
      // 活动组别
      group: {
        title: '活动组别',
        hover: '例：少年组；成年组；',
        add: '添加组别',
        name: '组别名称'
      },
      // 活动表单
      form: {
        title: '报名表单',
        hover: '报名者需要的填写信息内容；不同分类或组别，可以使用不同的报名表单',
        create: '创建活动报名信息'
      },
      // 报名收费
      charge: {
        title: '报名收费',
        hover: '不同分类或组别，可使用设置不同的费用'
      },
      // 详情配置设定
      config: {
        title: '详情配置设定：',
        hover: '不同分类或组别，可设置不同的评选规则、评选标准、评选方式、评选人数、评选结果公布时间等',
        // 同组重复报名：
        repeat: {
          title: '同组重复报名：',
          hover: '一个分组活动是否允许用户以相同的信息报名多次',
          default: '关闭'
        },
        // 报名审核通过：
        pass: {
          title: '报名审核通过：',
          hover: '用户提交报名后，是否默认通过系统审核判断报名是否有效/无效',
          default: '自动通过',
          // 先审后付
          prepay: '先审后付',
          // 先付后审
          postpay: '先付后审'
        },
        // 报名中心显示：
        show: {
          title: '报名中心显示：',
          hover: '“个人”：填写一个人信息时的报名；“团队”：是多人信息组成的一个报名，共享一副作品',
          default: '显示'
        },
        // 分组报名形式：
        form: {
          title: '分组报名形式：',
          hover: '“个人”：填写一个人信息时的报名；“团队”：是多人信息组成的一个报名，共享一副作品',
          default: '个人',
          team: '团队',
          min: '团队最小人数：',
          max: '团队最大人数：'
        },
        // 基础评判功能：
        base: {
          title: '基础评判功能：',
          hover: '是否开启基础评判功能；例：开启 或 关闭',
          default: '关闭'
        },
        // 合作伙伴佣金：
        commission: {
          title: '合作伙伴佣金：',
          hover: '合作伙伴作为主办方下级渠道商，设置报名费用的返佣金额比例偶',
          default: '关闭'
        },
        // 评选序号继承：
        inherit: {
          title: '评选序号继承：',
          hover: '主菜单中的高级评选管理中可设定报名作品评选序号，在晋级时可将序号继承至下一轮',
          default: '关闭'
        }
      }
    },
    // 场次信息
    session: {
      title: '场次信息',
      desc: '提示：当前场次创建仅关联上一步所创建的分组活动，多个组别活动有场次安排，请先完成活动初步创建后，进入活动管理，点击 “活动配置 - 分赛配置 - 场次配置”在其中进行配置。单个组别可以创建多个场次，不同组别也能创建不同场次。',
      name: '小组活动',
      // $t('input', { text: '' })
      // 报名人数
      number: {
        title: '报名人数',
        hover: '报名人数为单独场次中的设定，若有多个场次需要分别设定每个场次的人数',
        config: '设置',
        default: '无限制'
      },
      // 场次安排
      arrange: {
        title: '场次安排',
        hover: '若未定好相关场次安排，可关闭；若已有场次安排，可开启进行设置，支持线上及线下',
        default: '关闭'
      },
      // 场次形式：
      form: '场次形式：',
      // 在线地址
      online: '在线地址',
      // 线下地址
      // 地区选择
      offline: '地区选择',
      // 详细地址
      address: '详细地址',
      // 场次时间
      time: '场次时间'
    }
  },
  // 报名详情
  报名详情: '报名详情',
  // 报名编号
  报名编号: '报名编号'
}



// WEBPACK FOOTER //
// ./src/langs/zh_cn/activity.js